import { Initialize } from 'pacto';

import { Picture as View } from '../views/Picture';


export class Action extends Initialize {
  get settings() {
    return {
      selector: '.picture',
      namespace: 'picture:views',
      view: View,
    };
  }
}
